module.exports = __webpack_public_path__ + "static/media/caret_icon.2948680f.svg";